import { render, staticRenderFns } from "./RetailersProfileRightCard.vue?vue&type=template&id=28e7e120&scoped=true"
import script from "./RetailersProfileRightCard.vue?vue&type=script&lang=js"
export * from "./RetailersProfileRightCard.vue?vue&type=script&lang=js"
import style0 from "./RetailersProfileRightCard.vue?vue&type=style&index=0&id=28e7e120&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7e120",
  null
  
)

export default component.exports